export default __webpack_public_path__ + "static/media/RealEstatePaerner150x100.4ed54587.svg";